import React, { useRef, useState } from 'react';
import { Desktop, Mobile } from '../../../App';
import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';
import { CaptionText, H3, H4, P2, P3 } from '../../../styles/FontStyles';
import { ArrowChevron, Flexed } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Collapsable, HubArrow, HubImage, HubStyled } from './Hub.styled';
import { useTranslation } from 'react-i18next';

export const Hub = ({
  id,
  image,
  title,
  price,
  priceToShow,
  packagePrice,
  selectedLicence,
  button,
  weeklyCap,
  info,
  limitedQuantity,
  dobuleTradingBinaries,
  willyMemeCoins,
  stakingHubDetails,
  condensed,
  onClick,
  selected,
  currency,
  includesSubscription,
  isMemeBonusActivated,
  subtitle,
  tickets,
  subscriptionPrice,
  showTickets
}: any) => {
  const { t } = useTranslation('marketplace');

  const [expanded, setExpanded] = useState(false);

  const ref = useRef<any>(null);
  const elementHeight = ref?.current?.clientHeight;

  const wide = window.innerWidth > 800;

  const showSubtitleText = () => {
    if (subtitle !== null && subtitle !== undefined) {
      return (
        <>
          <Desktop>
            {showTickets ? (
              <>
                <P3 bold right caps>
                  {subtitle} <span>{tickets}</span>
                </P3>
              </>
            ) : (
              <>
                <P3 bold right caps>
                  {title === 'Bronze' || title === 'Gold' || title === 'Silver'
                    ? ''
                    : subtitle}
                </P3>
                <P3 bold caps right color={colors.secondary100}>
                  {tickets === '+null ticket' ? '' : tickets}
                </P3>
              </>
            )}
          </Desktop>
          <Mobile>
            <Flexed between>
              <P3 bold right caps>
                {title === 'Gold' || title === 'Silver' ? '' : subtitle}
              </P3>
              <P3 bold caps right color={colors.secondary100}>
                {tickets === '+null ticket' ? '' : tickets}
              </P3>
            </Flexed>
          </Mobile>
        </>
      );
    } else if (willyMemeCoins !== null && willyMemeCoins !== undefined) {
      return (
        <>
          <Desktop>
            <P3 bold right caps>
              willy meme coins
            </P3>
            <P3 bold caps right color={colors.secondary100}>
              +{formatUSDNoDecimals(willyMemeCoins)} per day*
            </P3>
          </Desktop>
          <Mobile>
            <Flexed between>
              <P3 bold right caps>
                willy meme coins
              </P3>
              <P3 bold caps right color={colors.secondary100}>
                +{formatUSDNoDecimals(willyMemeCoins)} per day*
              </P3>
            </Flexed>
          </Mobile>
        </>
      );
    }
  };
  return (
    <HubStyled
      condensed={condensed}
      selected={selected}
      includesSubscription={includesSubscription}>
      <div>
        <HubImage condensed={condensed} image={image} />
        <div>
          <Flexed column between>
            <div>
              <Desktop>
                <H3 color={selected ? colors.primary900 : ''} mb='4'>
                  {title}
                </H3>
              </Desktop>
              <Mobile>
                <H4
                  color={expanded ? colors.primary900 : ''}
                  onClick={() => setExpanded(!expanded)}
                  mb='4'
                  mr='20'>
                  {title}
                </H4>
              </Mobile>

              {priceToShow ? (
                <P2 mb='12' color={colors.neutral900}>
                  {priceToShow}
                </P2>
              ) : subscriptionPrice ? (
                <>
                  <P2 color={colors.neutral900}>
                    {formatUSDNoDecimals(price)} {currency || USDT} Membership
                  </P2>
                  <P2 color={colors.neutral900}>
                    {formatUSDNoDecimals(subscriptionPrice)} {currency || USDT}{' '}
                    Subscription
                  </P2>
                  {selectedLicence && (
                    <P2 color={colors.neutral900}>
                      {formatUSDNoDecimals(selectedLicence.price)}{' '}
                      {currency || USDT} BO subscription
                    </P2>
                  )}
                </>
              ) : (
                <P2 mb='12' color={colors.neutral900}>
                  {formatUSDNoDecimals(price)} {currency || USDT}{' '}
                  {`${(id > 220 && id < 225) || id === 1 ? 'yearly' : ''} `}
                </P2>
              )}
            </div>
          </Flexed>
          <Flexed column between>
            {includesSubscription && (
              <CaptionText bold mb='4' color={colors.neutral900}>
                {showTickets ? (
                  <>
                    {' '}
                    Includes {includesSubscription}-YEAR <br />
                    Back-Office
                    <br /> Subscription
                  </>
                ) : (
                  <>
                    Includes {includesSubscription}-Year <br /> Back-Office
                    Subscription
                  </>
                )}
              </CaptionText>
            )}
          </Flexed>
        </div>
      </div>
    </HubStyled>
  );
};
